export class Webnar {

    public id: string = "0";
    public name: string;
    public name_en: string;
    public url: string;
    public created: Date;

    constructor() {}
}